import { useRef, useEffect } from 'react';
import { Content } from './multi-input-item.styled';

export const MultiInputItem = (props) => {
  const { className, onChange, name, checked, indeterminate, ...rest } = props;
  const ref = useRef(null);

  // `indeterminate` is a DOM property, not an attribute — set it imperatively.
  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = !!indeterminate && !checked;
    }
  }, [indeterminate, checked]);

  const cl = (className ?? '') + ' multi';
  return (
    <Content className={cl} {...rest}>
      <input ref={ref} type="checkbox" onChange={onChange} name={name} checked={checked} />
      <span>{name}</span>
    </Content>
  );
};
